let info = {
  name: "Amalina Ahmad",
  logo_name: "Amalinaahmad",
  flat_picture: require("./src/assets/avatar-01.png"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false,
    },
  },
  description:
    "Hi , My Name is Amalina , and I am a developer living in <br> Malaysia & working remotely with the whole world",
  links: {
    linkedin: "https://www.linkedin.com/in/amalina-ahmad-983324b8/",
    github: "https://github.com/AmalinaAhmad",
    gitlab: "https://gitlab.com/AmalinaAhmad",
    resume: "https://drive.google.com/file/d/1QU3goJEIzIs6020hq3BlMo2IDmdOCDme/view?usp=drive_link",
  },
  education: [
    {
      name: "Kolej Matrikulasi ",
      place: "Melaka",
      date: "May, 2012 - May, 2013",
      degree: "Science Module",
      skills: ["Chemistry", "Information Technology", "Biology"],
    },
    {
      name: "Universiti Kebangsaan Malaysia",
      date: "Sept, 2013 - Jan, 2017",
      degree: "Bachelors in Software Engineering",
      description:
        "Graduated from Universiti Kebangsaan Malaysia with a Bachelor Degree in Software Engineering ( Multimedia System Development).",
      skills: [
        "Web Development",
        "Game Development",
        "System Requirement",
        "UI/UX",
        "Software Engineering",
      ],
    },
  ],
  experience: [
    {
      name: "Nazrol Tech Sdn Bhd",
      place: "Ara Damansara, Subang Jaya",
      position: "Game Developer",
      description:
        "Work as a developer to create ios and android version for Waspada Budaya Kita (Learning Mobile Application) - Handle Storyboard , Development , Testing , Debugging and App Publishing (Playstore & Apps Store) .",
      skills: ["Unity3D", "PHP", "C#", "VR"],
    },
    {
      name: "I-Serve Group of Companies",
      place: "Subang, Selangor",
      position: "Developer",
      description:
        "Work as a developer to create android version for Virtual Shopping Interaction 3D, Handle optimization , Lighting Scene Management , User Interface interaction",
      skills: ["C#", "Unity3D"],
    },
    {
      name: "HLA Integrated Sdn Bhd",
      position: "Full Stack Developer",
      description:
        "Develop Asset Management System using microservices technology",
      skills: ["Reactjs", "Nodejs", "Docker", "PostgresQL", "Microservices"],
    },
    {
      name: "Diqih Tech Sdn Bhd",
      position: "Developer , Data Migrator",
      description:
        "Develop Module For Licensing Module , while working as lead data migrator to transfer old data to new system structure",
      skills: ["Laravel", "MySQL"],
    },
  ],
  skills: [
    {
      title: "Languages",
      info: ["C#", "Javascript", "PHP", "SQL"],
      icon: "fas fa-code",
    },
    {
      title: "Game Software",
      info: ["Unity3D"],
      icon: "fas fa-cubes",
    },
    {
      title: "Web Technologies",
      info: ["Laravel", "ReactJS", "GatsbyJS", "CSS"],
      icon: "fas fa-laptop-code",
    },
    {
      title: "Databases",
      info: ["MongoDB", "MySQL"],
      icon: "fas fa-database",
    },
    {
      title: "Operating systems & Tools",
      info: ["MacOS", "Windows", "Linux", "Android", "JIRA"],
      icon: "fas fa-tools",
    },
    {
      title: "Design",
      info: ["Adobe Illustrator", "Adobe XD , Figma"],
      icon: "fas fa-pencil-square-o",
    },
  ],
  portfolio: [
    {
      name: "AR PosCard Raya",
      pictures: [
        {
          img: require("./src/assets/amalina/projek6.png"),
        },
      ],
      descriptions: "AR PosCard Raya",
      sub_des: "Augmented Reality Application",
      stack: "AR - Unity3D",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/pos-card/arpostcard.jpeg"),
        },
      ],
      news:
        "https://www.nst.com.my/news/nation/2018/05/371710/pos-malaysia-introduces-3d-hologram-hari-raya-greeting-cards",
    },

    {
      name: "Hunting With E - Language",
      stack: "AR - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek13.png"),
        },
      ],
      descriptions: "Hunting With E - Language",
      sub_des: "Augmented Reality Quiz For Universiti Putra Malaysia",
      video_link: "https://www.youtube.com/watch?v=66ZhxQU_c6E",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/hunting/1.png"),
        },
        {
          img: require("./src/assets/asset-details/hunting/2.png"),
        },
      ],
    },

    {
      name: "Decorax",
      stack: "AR Markerless- Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek10.png"),
        },
      ],
      descriptions: "Decorax",
      sub_des: "Augmented Reality Furniture",
      video_link: "https://www.youtube.com/watch?v=Y64wzDe5FuE",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/decorax/1.png"),
        },
        {
          img: require("./src/assets/asset-details/decorax/2.png"),
        },
      ],
    },

    {
      name: "Waspada Budaya Kita ( Rendah )",
      stack: "Mobile Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek2.png"),
        },
      ],
      descriptions: "Waspada Budaya Kita ( Rendah )",
      sub_des: "Mobile Application For Children - ( JKJR )",
      video_link: "https://www.youtube.com/watch?v=fvkknVeOy8U",
      google_play:
        "https://m.apkpure.com/waspada-budaya-kita-taska-rendah/com.PKJRRENDAH.PKJRRENDAH",

      picture_slide: [
        {
          img: require("./src/assets/asset-details/waspada/1.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada/2.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada/3.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada/4.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada/5.png"),
        },
      ],
    },
    {
      name: "Waspada Budaya Kita ( Menengah )",
      stack: "Mobile Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek3.png"),
        },
      ],
      descriptions: "Waspada Budaya Kita ( Menengah )",
      sub_des: "Mobile Application For Teen - ( JKJR )",
      video_link: "https://www.youtube.com/watch?v=p9wQTq4Hi50",
      google_play:
        "https://m.apkpure.com/waspada-budaya-kita-menengah/com.PKJRMEN.PKJRMEN",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/waspada-men/1.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada-men/2.png"),
        },
        {
          img: require("./src/assets/asset-details/waspada-men/3.png"),
        },
      ],
    },
    {
      name: "Animasi Falak",
      stack: "Courseware - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek15.png"),
        },
      ],
      descriptions: "Animasi Falak",
      sub_des: "Courseware for Jabatan Mufti Perak",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/falak/1.png"),
        },
        {
          img: require("./src/assets/asset-details/falak/2.png"),
        },
      ],
    },

    {
      name: "Interactive Application For Johor",
      stack: "Courseware - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek19.png"),
        },
      ],
      descriptions: "Interactive Application",
      sub_des: "Courseware for Johor",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/interactive/1.png"),
        },
        {
          img: require("./src/assets/asset-details/interactive/2.png"),
        },
      ],
      video_link: "https://www.youtube.com/watch?v=8USNlCEqXY8",

    },

    {
      name: "JD SPORT",
      stack : "Mobile Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek17.png"),
        },
      ],
      descriptions: "JD SPORT",
      sub_des: "Mobile Application For JD Sport Launching Store Thailand",
      video_link: "https://www.youtube.com/watch?v=wTvhYKcZtS0",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/king/1.jpeg"),
        },
      ],
    },

    {
      name: "Mobile Game Learning IQRA ",
      stack : "Mobile Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek20.png"),
        },
      ],
      descriptions: "Mobile Game Learning IQRA",
      sub_des: "Mobile Application For Student",
      // video_link: "https://www.youtube.com/watch?v=wTvhYKcZtS0",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/iqra/1.png"),
        },
        {
          img: require("./src/assets/asset-details/iqra/2.png"),
        },
        {
          img: require("./src/assets/asset-details/iqra/3.png"),
        },
      ],
    },
    {
      name: "PC Simulation",
      stack : "Desktop App - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek21.png"),
        },
      ],
      descriptions: "PC Simulation",
      sub_des: "PC Hardware Simulation",
      video_link: "https://www.youtube.com/watch?v=4n5lDEzGKiE",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/pc/1.png"),
        },
        {
          img: require("./src/assets/asset-details/pc/2.png"),
        },
       
      ],
    },

    
    {
      name: "Hang Tuah And Legendary Pencil",
      stack : "Mobile Game - Unity3D",

      pictures: [
        {
          img: require("./src/assets/amalina/projek4.png"),
        },
      ],
      descriptions: "Hang Tuah And Legendary Pencil",
      sub_des: "Platformer Game ( Mobile )",
      video_link: "https://www.youtube.com/watch?v=29cPu0dNwjM",
      google_play:
        "https://play.google.com/store/apps/details?id=com.yeayyy.ninja.pencil",
    },

    {
      name: "VR FPS",
      stack : "VR Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek9.png"),
        },
      ],
      descriptions: "VR FPS",
      sub_des: "Virtual Reality Application FPS ( UKM )",
      video_link: "https://www.youtube.com/watch?v=vj0bymbe00g",
    },
    {
      name: "FPS Game ( PC )",
      stack : "Desktop Game - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek18.png"),
        },
      ],
      descriptions: "FPS Game ( PC )",
      sub_des: "Final Year Project FPS ( UKM )",
      video_link: "https://www.youtube.com/watch?v=NEfSZTzdbnU",
    },

   
    // {
    //   name: "Shiseido Proffesional Augmented Reality",
    //   stack : "AR Application - Unity3D",
    //   pictures: [
    //     {
    //       img: require("./src/assets/amalina/projek12.png"),
    //     },
    //   ],
    //   descriptions: "Shiseido Proffesional Augmented Reality",
    //   sub_des: "Augmented Reality Logo Effect",
    //   apps: "https://apps.apple.com/my/app/color-mixology/id1454908825",
    // },
    {
      name: "Aliff Dan Amani",
      stack : "AR Application Publish To IOS - Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek14.png"),
        },
      ],
      descriptions: "Aliff Dan Amani",
      sub_des: "App Store Publishing ( IOS )",
    },

    {
      name: "Publika Senandung Raya",
      stack : "AR Application Publish To IOS- Unity3D",
      pictures: [
        {
          img: require("./src/assets/amalina/projek16.png"),
        },
      ],
      descriptions: "Publika Senandung Raya",
      sub_des: "App Store Publishing ( IOS )",
    },

    {
      name: "Learning 2D ( Mobile Apps )",
      pictures: [
        {
          img: require("./src/assets/amalina/projek1.png"),
        },
      ],
      descriptions: "Learning 2D ( Mobile Apps )",
      sub_des: "Learning 2D Game For Children",
      video_link: "https://www.youtube.com/watch?v=Cq-2JTIg3G0",
    },


    
    
  ],

  portfolio_web: [
    {
      name: "Distribution System",
      stack : "Web - .NET 4.8 , Adobe XD" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projek-katsys8.png"),
        },
      ],
      descriptions: "Distribution System",
      sub_des: "",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/katsys/1.png"),
        },
        {
          img: require("./src/assets/asset-details/katsys/2.png"),
        },
        {
          img: require("./src/assets/asset-details/katsys/3.png"),
        }
       
      ],
    },
    {
      name: "Salesman Visitation System",
      stack : "Web - .Ionic , Adobe XD" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projek-pwa.png"),
        },
      ],
      descriptions: "Salesman Visitation System",
      sub_des: "",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/pwa/1.png"),
        },
        {
          img: require("./src/assets/asset-details/pwa/2.png"),
        },
        {
          img: require("./src/assets/asset-details/pwa/3.png"),
        },
        {
          img: require("./src/assets/asset-details/pwa/4.png"),
        },
        {
          img: require("./src/assets/asset-details/pwa/5.png"),
        },
        {
          img: require("./src/assets/asset-details/pwa/6.png"),
        }
       
      ],
    },
    {
      name: "Licensing Management System",
      stack : "Web - Laravel , MySQL" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projek-sppik.png"),
        },
      ],
      descriptions: "Licensing Management System",
      sub_des: "",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/sppik/1.png"),
        },
    
       
      ],
    },
    {
      name: "Wedding Management System",
      stack : "Web - ReactJS , MySQL" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projek-kawwinai.png"),
        },
      ],
      descriptions: "Wedding Management System",
      sub_des: "",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/kawwin/1.png"),
        },
    
       
      ],
    },
    {
      name: "Company Website Development",
      stack : "Web - GatsbyJS ( React ) , Rest API , CMS , Digital Ocean" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projekweb1.png"),
        },
      ],
      descriptions: "Company Website Development",
      sub_des: "Company Website Development",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/ctrld/1.png"),
        },
        {
          img: require("./src/assets/asset-details/ctrld/2.png"),
        },
        {
          img: require("./src/assets/asset-details/ctrld/3.png"),
        },
       
      ],
    },

    {
      name: "Member Management System",
      stack : "Web - Laravel ( PHP ), Mysql " ,
      pictures: [
        {
          img: require("./src/assets/amalina/projekweb2.png"),
        },
      ],
      descriptions: "Member Management System",
      sub_des: "Member Management System",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/ekhairat/1.png"),
        },
        {
          img: require("./src/assets/asset-details/ekhairat/2.png"),
        },
        {
          img: require("./src/assets/asset-details/ekhairat/3.png"),
        },
       
      ],
    },

    {
      name: "Asset Management System",
      stack : "Web - ReactJS , NodeJS , PostgreSQL " ,
      pictures: [
        {
          img: require("./src/assets/amalina/projekweb3.png"),
        },
      ],
      descriptions: "Asset Management System",
      sub_des: "Asset Management System",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/gasset/1.jpg"),
        },
       
       
      ],
    },

    {
      name: "Learning Management System Landing Page",
      stack : "Web - ReactJS , Laravel" ,
      pictures: [
        {
          img: require("./src/assets/amalina/projekweb4.png"),
        },
      ],
      descriptions: "Learning Management System",
      sub_des: "Learning Management System",
      picture_slide: [
        {
          img: require("./src/assets/asset-details/lms/1.png"),
        },
       
       
      ],
    },

    ],
};

export default info;
